import Layout from './Layout';
import TabletLayout from './TabletLayout';
import { useDeviceLayout } from '../../lib/util/device';
import { Container } from 'reactstrap';

const AppLayout = ({ children }: { children: React.ReactNode }) => {
  const deviceType = useDeviceLayout();

  if (deviceType === 'tablet') {
    return <TabletLayout>{children}</TabletLayout>;
  }

  //   if (deviceType === 'mobile') {
  //     return <MobileLayout>{children}</MobileLayout>;
  //   }

  return (
    <Layout>
      <Container>{children}</Container>
    </Layout>
  );
};

export default AppLayout;
